var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-send-container"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.readyToUpload)?_c('Form',[_vm._t("default")],2):_c('Uploading')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }